import component from "./TextInput";
export default component;
